module.exports = require('os');